import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Link
} from "react-router-dom";
import { jwtDecode } from 'jwt-decode';

export default function Footer(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        jwtDecode(token); // Decode the token to verify it's valid
        setIsLoggedIn(true);
      } catch (error) {
        console.error('Invalid token:', error);
        setIsLoggedIn(false);
      }
    } else {
      setIsLoggedIn(false);
    }

  }, []);
  return (
    <>

      <div className='bg-[#FBF8F1] py-10'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={3}>
            <Grid item lg={3} md={12} xs={12}>
              <div className='mb-4'>
                <Link to="#"><img src='assets/images/logo.svg' className='w-40' /></Link>
              </div>
              <a href='mailto:help@jwlbook.com' className='block py-2'><i className="fa-solid fa-envelope text-[#B3902D] mr-2"></i> help@jwlbook.com</a>
              <a href='#' className='block py-2'><i className="fa-solid fa-globe text-[#B3902D] mr-2"></i> www.jwlbook.com</a>
            </Grid>
            <Grid item lg={6} md={12} xs={12}>
              <h3 className='mt-3 mb-4 text-[#A27800] uppercase font-semibold text-base'>Quick Links</h3>
              <Grid container spacing={3}>
                <Grid item lg={6} md={6} xs={6}>
                  <Link to="/about-us" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all hover:text-[#B3902D] hover:pl-1 transition-all">About Us</Link>
                  {isLoggedIn ? (
                    <>
                      <Link to="/listing" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Sell</Link>
                      <Link to="/listing" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Your Jewelry</Link>
                    </>
                  ) : (
                    <>
                      <Link to="/login" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Sell</Link>
                      <Link to="/login" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Your Jewelry</Link>
                    </>
                  )}
                  <Link to="/gold-price" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Gold Prices</Link>
                  <Link to="/silver-price" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Sliver Price</Link>
                </Grid>
                <Grid item lg={6} md={6} xs={6}>
                  {isLoggedIn ? (
                    <Link to="/dashboard" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">My Account</Link>
                  ) : (
                    <Link to="/login" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">My Account</Link>
                  )}

                  <Link to="/contact" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Contact Us</Link>
                  <Link to="/faq" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">FAQ’s</Link>
                  <Link to="/terms-conditions" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Terms & Conditions</Link>
                  <Link to="/privacy-policy" className="block py-2 hover:text-[#B3902D] hover:pl-1 transition-all">Privacy Policy</Link>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={3} md={12} xs={12}>
              <h3 className='mt-3 mb-4 text-[#A27800] uppercase font-semibold text-base'>Download APP</h3>
              <div className='flex gap-3 mt-5 mb-8'>
                <a href='#' target='_blank'><img src='assets/images/apple.png' className='h-[50px] object-contain' /></a>
                <a href='#' target='_blank'><img src='assets/images/google.png' className='h-[50px] object-contain' /></a>
              </div>
              <h3 className='mt-3 mb-4 text-[#A27800] uppercase font-semibold text-base'>Get in touch</h3>
              <div className='flex gap-3 mt-5'>
                <a href='#' className='w-10 h-10 bg-black text-white text-center rounded-full leading-10 hover:bg-[#B3902D]'><i className="fa-brands fa-facebook-f"></i></a>
                <a href='#' className='w-10 h-10 bg-black text-white text-center rounded-full leading-10 hover:bg-[#B3902D]'><i className="fa-brands fa-instagram"></i></a>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className='bg-[#F8F4EB] py-5'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={3}>
            <Grid item lg={6}>
              © Copyright 2025 jwlbook.com. All Rights Reserved
            </Grid>
            <Grid item lg={6} className='lg:text-right'>
              Designed By:<a href='https://www.goigi.com/' target='_blank'>GOIGI</a>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  )
}
